export default {
  deposit: {
    crypto: 'คริปโต',
    fiatOrCash: 'เงินสด/Fiat',
    depositCurrency: 'สกุลเงินที่ฝาก',
    chooseNetwork: 'เลือกเครือข่าย',
    depositAddress: 'ที่อยู่ฝากเงิน',
    copy: 'คัดลอก',
    copied: 'คัดลอกแล้ว!',
    close: 'ปิด',
    more: 'เพิ่มเติม',
    select: 'เลือก',
    channel: 'ช่องทาง',
    loading: 'กำลังโหลด...',
    noCurrency: 'ไม่มีสกุลเงินที่ใช้ได้',
    bonusTip: 'รับโบนัสเงินฝากในการเติมเงินครั้งแรก สูงสุด 200%',
    minDeposit: 'เงินฝากขั้นต่ำ',
    sendOnly: 'ส่งเฉพาะ {currency} ไปยังที่อยู่นี้เท่านั้น เงินจะถูกฝากอัตโนมัติหลังจากการยืนยันเครือข่าย {confirmations} ครั้ง',
    depositAmount: 'จำนวนเงินฝาก',
    enterAmount: 'ป้อนจำนวน',
    confirmDeposit: 'ยืนยันการฝาก',
    depositTitle: 'ฝากเงิน',
    selectChannel: 'เลือกช่องทาง',
    subtitle: 'รวดเร็ว ปลอดภัย และสะดวก',
    secureEncrypted: 'ปลอดภัยและเข้ารหัส',
    terms: 'เมื่อดำเนินการต่อ แสดงว่าคุณยอมรับข้อกำหนดและเงื่อนไขของเรา',
    totalDepositAmount: 'จำนวนเงินฝากทั้งหมด',
    fee: 'ค่าธรรมเนียม',
    arrivalAmount: 'จำนวนเงินที่ได้รับ',
    payMethod: 'วิธีการชำระเงิน',
    cpf: 'CPF',
    enterCpf: 'กรุณากรอก CPF',
    depositSuccess: 'ฝากเงินสำเร็จ!',
    depositFailed: 'ฝากเงินล้มเหลว กรุณาลองอีกครั้ง',
    mockArrive: 'จำลองการเข้าบัญชี (ทดสอบ)',
    activity: {
      firstChargeTitle: 'กิจกรรมลงทะเบียนเติมเงินครั้งแรก',
      firstChargeSubtitle: 'ลงทะเบียนการฝากครั้งแรกเพื่อรับรางวัลพิเศษ',
      dailyThreeTitle: 'เติมเงินสามครั้งต่อวัน',
      dailyThreeSubtitle: 'ทำการฝากครบ 3 ครั้งต่อวันเพื่อรับโบนัสเพิ่ม',
      dailyPreviewLabel: 'รางวัลเติมเงินครั้งแรก',
      upTo: 'สูงสุด {amount} {unit}',
      safeTitle: 'เงินของคุณปลอดภัยกับเรา',
      safeDesc: 'เราใช้ระบบความปลอดภัยชั้นนำของอุตสาหกรรมเพื่อปกป้องธุรกรรมและข้อมูลส่วนตัวของคุณ',
      dailyFirst: 'เติมเงินครั้งที่ 1',
      dailySecond: 'เติมเงินครั้งที่ 2',
      dailyThird: 'เติมเงินครั้งที่ 3',
      lossReward: 'คืนเงินจากการขาดทุน',
      lossRewardSubtitle: 'รับเงินคืนจากการขาดทุนของคุณ',
      rebateUpTo: 'คืนเงินสูงสุด {ratio}%',
      notEligible: 'คุณไม่สามารถเข้าร่วมกิจกรรมนี้ได้อีก',
      lossNeedSelect: 'เลือกกิจกรรมนี้เมื่อฝากเงินเพื่อเข้าร่วมรับเงินคืน',
      claimed: 'รับแล้ว',
      claim: 'รับ',
      noTier: 'ไม่มีระดับ',
      claimWillOpen: 'การรับเปิดเวลา {time}',
      claimTimeNotReached: 'ยังไม่ถึงเวลารับ กรุณากลับมาหลัง {time}',
      bonus: 'โบนัส',
      rebate: 'คืนเงิน',
      depositGE: 'ฝาก ≥ {amount}',
      lossGE: 'ขาดทุน ≥ {amount}',
      claimSuccess: 'รับสำเร็จ',
      claimFailed: 'รับไม่สำเร็จ',
      alreadyClaimed: 'คุณรับระดับนี้แล้ว กรุณาอย่ากดซ้ำ',
      lossAlreadyClaimed: 'คุณรับคืนเงินขาดทุนระดับนี้แล้ว กรุณาอย่ากดซ้ำ',
      requireLogin: 'กรุณาเข้าสู่ระบบก่อนรับ',
      depositNotEnough: 'จำนวนเงินฝากยังไม่ถึงเกณฑ์ พยายามต่อไป!',
      lossNotEnough: 'จำนวนการขาดทุนเมื่อวานยังไม่ถึงเกณฑ์',
      onlyHighest: 'รางวัลของกิจกรรมนี้รับได้เฉพาะระดับสูงสุดเท่านั้น',
    },
  },
};
